import { render } from "./TrxStfAmd.vue?vue&type=template&id=50ea7852"
import script from "./TrxStfAmd.vue?vue&type=script&lang=js"
export * from "./TrxStfAmd.vue?vue&type=script&lang=js"

import "./TrxStfAmd.vue?vue&type=style&index=0&id=50ea7852&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__